import CrisisAlertIcon from '@mui/icons-material/CrisisAlert';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { MeinBereichButton, MeinBereichPaper } from '../../../../components/ui-component/mein-bereich/MeinBereichComponents';
import { ANTRAGS_STATUS } from '../../../../lib/constants/constant';
import { PAGES_URLS } from '../../../../lib/constants/routes';
import { enumT, getFieldNamefromDataPath } from '../../../../utils/helper';

// import Schemas
import AntragSchema from '../../../../lib/paths/antrag_FULL_Paths.json';
const P = AntragSchema.attributes;

function VorDerForderung() {
	const navigate = useNavigate();

	return (
		<>
			<MeinBereichPaper titleIcon={<CrisisAlertIcon sx={{ color: 'black' }} />} title={'Ich möchte'}>
				<MeinBereichButton
					variant='antragAnlegen'
					buttonName='Einen neuen Antrag erstellen'
					onClick={() => {
						navigate(PAGES_URLS.CreateAntrag);
					}}
				/>
				<MeinBereichButton
					variant='antragAnlegen'
					buttonName='Einen Antrag bearbeiten'
					onClick={() => {
						navigate(PAGES_URLS.MeineFoerderung, {
							state: {
								filter: {
									field: getFieldNamefromDataPath(P.Status_Status.path),
									operator: 'contains',
									value: enumT(ANTRAGS_STATUS.inBearbeitung),
								},
							},
						});
					}}
				/>
				<MeinBereichButton
					variant='antragAnlegen'
					buttonName='Eingereichte Anträge ansehen'
					onClick={() => {
						navigate(PAGES_URLS.MeineFoerderung, {
							state: {
								filter: {
									field: getFieldNamefromDataPath(P.Status_Status.path),
									operator: 'contains',
									value: enumT(ANTRAGS_STATUS.inPruefung),
								},
							},
						});
					}}
				/>
			</MeinBereichPaper>
		</>
	);
}

export default VorDerForderung;
